import HttpService from "./htttp.service";

class AuthService {
   //authEndpoint = process.env.API_URL;

  login = async (payload) => {
    const loginEndpoint = 'login';
    const response = await HttpService.post(loginEndpoint, payload);

    // Salva o cookie manualmente para garantir que o Site (porta 3003) consiga ler.
    if (response.access_token) {
      const isProd = process.env.NODE_ENV === 'production';
      const domainAttr = isProd ? '; domain=.djparafestas.com.br' : ''; // Vazio = localhost (host-only)
      const secureAttr = isProd ? '; Secure' : '';
      document.cookie = `dj_auth_token=${response.access_token}; path=/${domainAttr}; max-age=86400; samesite=Lax${secureAttr}`;
    }

    return response;
  };

  register = async (credentials) => {
    const registerEndpoint = 'register';
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = 'logout';
    
    // Limpa o cookie de autenticação compartilhado ao fazer logout
    const isProd = process.env.NODE_ENV === 'production';
    const domainAttr = isProd ? '; domain=.djparafestas.com.br' : ''; 
    document.cookie = `dj_auth_token=; path=/${domainAttr}; max-age=0;`;

    try {
      return await HttpService.post(logoutEndpoint);
    } catch (error) {
      return null;
    }
  };

  forgotPassword = async (payload) => {
    const forgotPassword = 'password-forgot';
    return await HttpService.post(forgotPassword, payload);
  }

  resetPassword = async (credentials) => {
    const resetPassword = 'password-reset';
    return await HttpService.post(resetPassword, credentials);
  }

  getProfile = async() => {
    const getProfile = 'me';
    return await HttpService.get(getProfile);
  }

  updateProfile = async (newInfo) => {
    const updateProfile = "me";
    return await HttpService.patch(updateProfile, newInfo);
  }

  mediaUpload = async (data) => {
    const mediaUpload = "upload";
    return await HttpService.post(mediaUpload, data);
  }

  mediaUpdate = async (data, id) => {
    const mediaUpdate = `update/${id}`;
    return await HttpService.post(mediaUpdate, data);
  }

  deleteMedia = async (id) => {
    return await HttpService.delete(`media/${id}`);
  };

}

export default new AuthService();
